import React from 'react';
import { IconBaseProps } from 'react-icons/lib';

const Icon = (props: IconBaseProps) => (
	<svg
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M12.0008 7C8.50078 7 5.51178 9.177 4.30078 12.25C5.51178 15.323 8.50078 17.5 12.0008 17.5C15.5008 17.5 18.4898 15.323 19.7008 12.25C18.4898 9.177 15.5008 7 12.0008 7ZM12.0008 15.75C10.0688 15.75 8.50078 14.182 8.50078 12.25C8.50078 10.318 10.0688 8.75 12.0008 8.75C13.9328 8.75 15.5008 10.318 15.5008 12.25C15.5008 14.182 13.9328 15.75 12.0008 15.75ZM12.0008 10.15C10.8388 10.15 9.90078 11.088 9.90078 12.25C9.90078 13.412 10.8388 14.35 12.0008 14.35C13.1628 14.35 14.1008 13.412 14.1008 12.25C14.1008 11.088 13.1628 10.15 12.0008 10.15Z"
			fill={props.color}
		/>
	</svg>
);

export default Icon;
